import React from 'react';
import styles from './svg.css';

const Rx = () => (
  <svg
    version="1.1"
    className={styles.rx}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 50"
  >
    <title>Rx</title>
    <path
      className="st1"
      d="M32.3,47h3.9l-6.1-8l5.7-7.5h-3.5l-4,5.5L16.6,21.8l0.5-0.1c6.5-1.5,7.9-5.8,7.9-9.2c0-6.7-4.8-10.1-14.2-10.1
  c-3.4,0-8.1,0.3-9.3,0.4v36h3.4V23.1h5.5c1,0,2,0,2.9-0.1h0.2L26,39.1L20,47h3.5l4.4-5.8L32.3,47z M10.9,20.5h-6V5h0.3
  c0,0,3.7-0.2,5.5-0.2c7,0,10.8,2.7,10.8,7.6C21.5,15.5,20.1,20.5,10.9,20.5z"
    />
  </svg>
);

export default Rx;



// WEBPACK FOOTER //
// ./src/assets/Rx.jsx